// extracted by mini-css-extract-plugin
export default {"root":"Tools_root__k8sK-"};